var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneSideNav = function SvgPhoneSideNav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.148 2.628c.053.79.186 1.565.4 2.303L2.48 5.998a13.183 13.183 0 0 1-.676-3.37h1.343Zm8.767 10.688c.756.213 1.53.346 2.312.4v1.325a13.724 13.724 0 0 1-3.379-.667l1.067-1.058ZM4.001.849H.89C.4.85 0 1.25 0 1.74c0 8.349 6.767 15.116 15.116 15.116.49 0 .89-.4.89-.89v-3.103c0-.489-.4-.889-.89-.889-1.102 0-2.178-.178-3.174-.507a.746.746 0 0 0-.276-.044.91.91 0 0 0-.631.258l-1.956 1.956a13.47 13.47 0 0 1-5.86-5.86L5.175 5.82a.892.892 0 0 0 .222-.907 10.102 10.102 0 0 1-.506-3.175c0-.489-.4-.889-.89-.889Z",
    fill: "#2B2B2B"
  })));
};
export default SvgPhoneSideNav;